'use strict';
var slickConfigs = require('../config/slickConfigs');
var utils = require('../utils');

/**
 * Init globally reusable carousels
 */

module.exports = {
    heroCarousels: function () {
        $('.hero-caro').slick(slickConfigs.hero);
    },
    productTileCarousels: function () {
        $('.product-tile-caro').slick(slickConfigs.productTiles);
    },
    homePageCarousels: function () {
        $('.key-art-carousel').slick(slickConfigs.homePage);
    },
    recentlyViewedCarousels: function () {
        $('.recently-viewed-carousel').slick(slickConfigs.recentlyViewedProductTiles);
    },
    bundleIncludedCarousel: function () {
        $('.bundle-includes-carousel').slick(slickConfigs.bundleIncludedCarousel);
    },
    bundleProductDetailsCarousel: function () {
        $('.bundle-product-details-carousel').not('.slick-initialized').slick(slickConfigs.bundleIncludedCarousel);
    },
    gameinformerIssueCarousel: function () {
        $('.gameinformer-issue-carousel').slick(slickConfigs.gameinformerIssueCarousel);
    },
    recommendationRedesignHomepage: function () {
        $('.recommendedProductsOnHomepageRedesign').each(function(){$(this).not('.slick-initialized').slick(slickConfigs.recommendedProductsRedesignPDP)});
    },
    accountDashboardWishlistCarousel: function () {
        if (utils.mediaBreakpointDown('md')) {
            $('.account-dashboard-wishlist .wishlistItemCards').slick(slickConfigs.accountDashboardWishlistCarousel);
        }
    },
    activeOffersCarousel: function () {
        $('.active-offers-carousel').slick(slickConfigs.activeOffersCarousel);
    },
    dashboardOrderItemsCarousel: function () {
        $('.dashboard-order-items-carousel').slick(slickConfigs.dashboardOrderItemsCarousel);
    },
    dashboardRewardsCenterCarousel: function () {
        $('.dashboard-reward-center .reward-tile-group').slick(slickConfigs.dashboardRewardsCenterCarousel);
    }
};
